import React, { useEffect, useMemo, useState } from "react";
import { useProperty } from "../../context/PropertyContext";
import Spinner from "../Loader/Spinner";

const SelectProperty = ({ rooms, setRooms, setStep, close }) => {
  const [property, setProperty] = useState("");

  const handleWorkingDays = (index) => {
    setRooms(allAddedRooms.map((item, i) => (i === index ? { ...item, selected: !item.selected } : item)));
  };
  const { properties, done, loading, createrooms } = useProperty();

  const neededRooms = useMemo(() => {
    return rooms.filter((item) => item.room !== "" && item.selected);
  }, [rooms]);

  const allAddedRooms = useMemo(() => {
    return rooms.filter((item) => item.room !== "");
  }, [rooms]);

  const propertyList = useMemo(() => {
    return properties.map((property) => property.propertyName);
  }, [properties]);

  const handleSubmit = async () => {
    await createrooms({ rooms: neededRooms, propertyName: property });
  };

  useEffect(() => {
    done && close();
  }, [close, done]);

  useEffect(() => {
    neededRooms.length === 0 && setProperty("");
  }, [neededRooms.length, setProperty]);
  return (
    <div className="p-12">
      <div className="flex gap-2 items-center">
        <button
          onClick={() => setStep(2)}
          className={`px-4 h-[40px] focus:outline-none sticky min-w-[150px] bg-primary text-white rounded text-[12px] flex items-center justify-center`}
        >
          Add New Room room{" "}
        </button>

        <div className="my-8 flex  md:flex-row justify-start items-center flex-col gap-3  w-full md:w-[400px] overflow-x-scroll no-scrollbar">
          {allAddedRooms.map((item, index) => (
            <button
              key={index}
              onClick={() => handleWorkingDays(index)}
              className={`px-2 h-[40px] min-w-[100px] ${
                item.selected ? "bg-primary text-white rounded" : "border border-primary rounded text-primary"
              } text-[12px] flex items-center justify-center`}
            >
              {item.room}
            </button>
          ))}
        </div>
      </div>
      {neededRooms.length === 0 && <p className="text-[red] italic mt-3 text-center text-[16px]">No room selected </p>}
      {propertyList.length === 0 && <p className="text-[red] italic mt-3 text-center text-[16px]">You have not created any property yet</p>}
      {neededRooms.length > 0 && propertyList.length > 0 && (
        <>
          <p className="text-black relative font-semibold text-[16px] text-center mb-3">Select a Property </p>
          <div className="grid w-[40rem] grid-cols-4 space-x-2 rounded-xl bg-gray-200 p-2" x-data="app">
            {propertyList.map((property, index) => (
              <div key={index}>
                <input type="radio" name="option" id={index} className="peer hidden" />
                <label
                  onClick={() => setProperty(property)}
                  htmlFor={index}
                  className="block cursor-pointer select-none rounded-xl p-2 text-center peer-checked:bg-blue-500 peer-checked:font-bold peer-checked:text-white"
                >
                  {property}
                </label>
              </div>
            ))}
          </div>
          {neededRooms.length > 0 && property && (
            <p className="w-[550px] text-center text-[15px] mx-auto mt-4">
              You're about to add rooms:{" "}
              <b className="text-primary">
                {neededRooms?.map((property, index) => (index === neededRooms.length - 1 ? property.room : property.room + ", "))}
              </b>{" "}
              to property: <b>{property}</b>
            </p>
          )}
          {loading ? (
            <Spinner />
          ) : (
            <button
              onClick={handleSubmit}
              disabled={property === "" ? true : false}
              className={`px-4 h-[40px] mx-auto mt-12 sticky min-w-[150px] font-semibold text-[14px] ${
                property === "" ? "bg-gray-200 text-black cursor-not-allowed" : "bg-primary text-white "
              }  rounded text-[12px] flex items-center justify-center`}
            >
              Add Room(s)
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default SelectProperty;
